import { Paper, Typography } from '@mui/material';

interface StatCardProps {
  accent?: 'default' | 'warning';
  label: string;
  value: number | string;
}

export const StatCard = ({ accent = 'default', label, value }: StatCardProps) => (
  // TODO: Set this back to flex: 1 & remove maxWidth when we add back more than one StatCard in a row
  <Paper sx={{ maxWidth: 400, minWidth: 150, p: 2 }} variant="outlined">
    <Typography color={accent === 'warning' ? 'warning.main' : 'text.primary'} sx={{ fontWeight: 600 }} variant="h5">
      {value}
    </Typography>
    <Typography color="text.secondary" sx={{ display: 'block', mt: 0.25 }} variant="caption">
      {label}
    </Typography>
  </Paper>
);
